'use client';

import { FC } from 'react';
import type { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import { RevealOnScroll } from '@/components/common/RevealOnScroll';
import { cn } from '@/lib/utils';

type Props = { body: RichTextField; delay?: number; className?: string };

export const CalloutBody: FC<Props> = ({ body, delay = 0, className }) => (
  <RevealOnScroll
    delay={delay}
    className={cn(
      'w-full text-[16px] font-light leading-[1.5] text-white md:min-w-0 md:flex-1 md:text-[18px]',
      className,
    )}
  >
    <PrismicRichText
      field={body}
      components={{
        paragraph: ({ children }) => (
          <p className="[&:not(:first-child)]:mt-4">{children}</p>
        ),
        strong: ({ children }) => (
          <strong className="font-bold">{children}</strong>
        ),
        hyperlink: ({ children, node }) => (
          <a
            href={node.data.url ?? '#'}
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {children}
          </a>
        ),
      }}
    />
  </RevealOnScroll>
);
